import uuidv4 from 'uuid/v4';

interface Observers {
  id: string;
  cb: (observerId: string, action: string, data: any) => any;
}

export class Observable {
  observers: Array<Observers>;

  constructor() {
    this.observers = [];
  }

  subscribe(
    observerCallback: (observerId: string, action: string, data: any) => any
  ): string {
    const id = uuidv4();
    this.observers.push({
      id,
      cb: observerCallback
    });

    return id;
  }

  unsubscribe(observerId: string): void {
    this.observers = this.observers.filter(
      observer => observer.id !== observerId
    );
  }

  notify(action: string, data?: any): void {
    this.observers.forEach(({ id, cb }) => cb(id, action, data));
  }

  on(
    eventName: string,
    callback: (data?: any, observerId?: string) => void,
    unsubscribeAfterFirstEvent: boolean = false
  ): string {
    return this.subscribe((observerId, action, data) => {
      if (action === eventName) {
        callback(data, observerId);

        if (unsubscribeAfterFirstEvent) {
          this.unsubscribe(observerId);
        }
      }
    });
  }
}
